/** Labels de operadores de caja — barrel liviano (sin cashManagementUtils / sessions). */
export {
  buildCashOperatorOptions,
  buildSalesListCashierOptions,
  SALES_LIST_CASHIER_NULL_KEY,
} from './screens/cashOperatorLabels';
